import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_68735d90/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/tmp/build_68735d90/layouts/login.vue").then(m => m.default || m))
}